module.exports = __webpack_public_path__ + "media/guide_arrival.76b22873.mp3";